import { Button, Space, Upload } from 'antd';
import { DeleteOutlined, InboxOutlined, LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { InfoAlert, PrimaryButton, styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledUploadContentWrapper = styled(Space).withConfig({
  displayName: "upload-file-areacomponent__StyledUploadContentWrapper",
  componentId: "sc-1c9kluy-0"
})(["width:100%;text-align:center;"]);
var StyledUpload = styled(Upload).withConfig({
  displayName: "upload-file-areacomponent__StyledUpload",
  componentId: "sc-1c9kluy-1"
})(["background:#f5f5f5;display:flex;flex-direction:column;align-items:center;justify-content:center;height:250px;border:1px dashed #d9d9d9;border-radius:2px;&:hover{cursor:pointer;}.ant-upload-select{width:100%;}"]);
var StyledInfoAlert = styled.div.withConfig({
  displayName: "upload-file-areacomponent__StyledInfoAlert",
  componentId: "sc-1c9kluy-2"
})(["margin-top:12px;"]);
var StyledInboxIcon = styled(InboxOutlined).withConfig({
  displayName: "upload-file-areacomponent__StyledInboxIcon",
  componentId: "sc-1c9kluy-3"
})(["font-size:50px;"]);
var StyledGuide = styled.div.withConfig({
  displayName: "upload-file-areacomponent__StyledGuide",
  componentId: "sc-1c9kluy-4"
})(["text-align:center;"]);
var StyledText = styled.div.withConfig({
  displayName: "upload-file-areacomponent__StyledText",
  componentId: "sc-1c9kluy-5"
})(["font-weight:400;font-size:16px;line-height:24px;"]);
var StyledSubText = styled.div.withConfig({
  displayName: "upload-file-areacomponent__StyledSubText",
  componentId: "sc-1c9kluy-6"
})(["font-weight:400;font-size:14px;line-height:20px;"]);
var StyledPreviewArea = styled.div.withConfig({
  displayName: "upload-file-areacomponent__StyledPreviewArea",
  componentId: "sc-1c9kluy-7"
})(["position:relative;height:200px;width:100%;background:#f5f5f5;text-align:center;border:1px dashed #d9d9d9;border-radius:2px;"]);
var StyledImage = styled.img.withConfig({
  displayName: "upload-file-areacomponent__StyledImage",
  componentId: "sc-1c9kluy-8"
})(["height:100%;width:100%;object-fit:contain;"]);
var StyledLoadingIcon = styled(LoadingOutlined).withConfig({
  displayName: "upload-file-areacomponent__StyledLoadingIcon",
  componentId: "sc-1c9kluy-9"
})(["font-size:24px;"]);
var StyledSpaceContainer = styled(Space).withConfig({
  displayName: "upload-file-areacomponent__StyledSpaceContainer",
  componentId: "sc-1c9kluy-10"
})(["position:absolute;top:8px;right:8px;"]);
var StyledEditingButton = styled(Button).withConfig({
  displayName: "upload-file-areacomponent__StyledEditingButton",
  componentId: "sc-1c9kluy-11"
})(["border-radius:4px;background:", ";color:", ";"], styleVariables.colors.gray13, styleVariables.colors.gray1);
var StyledAlert = styled(InfoAlert).withConfig({
  displayName: "upload-file-areacomponent__StyledAlert",
  componentId: "sc-1c9kluy-12"
})(["display:flex;gap:12px;"]);
var defaultAcceptedImageFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
export var UploadFileArea = function UploadFileArea(props) {
  var signedUrl = props.signedUrl,
      isUploading = props.isUploading,
      onDeleteFile = props.onDeleteFile,
      isMultiple = props.isMultiple,
      label = props.label,
      onBeforeUpload = props.onBeforeUpload,
      allowedFileTypes = props.allowedFileTypes,
      disabled = props.disabled,
      _props$imageLimitMb = props.imageLimitMb,
      imageLimitMb = _props$imageLimitMb === void 0 ? 25 : _props$imageLimitMb;

  var renderUploadField = function renderUploadField() {
    var _label$fileHint;

    var content = isUploading ? /*#__PURE__*/_jsxs(StyledUploadContentWrapper, {
      direction: "vertical",
      size: "middle",
      children: [/*#__PURE__*/_jsx(StyledLoadingIcon, {}), label.uploading]
    }) : /*#__PURE__*/_jsxs(StyledUploadContentWrapper, {
      direction: "vertical",
      size: "middle",
      children: [/*#__PURE__*/_jsx(StyledInboxIcon, {}), /*#__PURE__*/_jsxs(StyledGuide, {
        children: [/*#__PURE__*/_jsx(StyledText, {
          children: label.dragToUpload
        }), /*#__PURE__*/_jsx(StyledSubText, {
          children: label.or
        })]
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        children: label.findFileFromDevice
      })]
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledUpload, {
        disabled: disabled || isUploading,
        maxCount: 1,
        showUploadList: false,
        name: "file",
        multiple: isMultiple !== null && isMultiple !== void 0 ? isMultiple : false,
        accept: allowedFileTypes ? allowedFileTypes.join(',') : defaultAcceptedImageFileTypes.join(','),
        beforeUpload: function beforeUpload(file) {
          onBeforeUpload(file);
          return false;
        },
        children: content
      }), /*#__PURE__*/_jsx(StyledInfoAlert, {
        children: /*#__PURE__*/_jsx(StyledAlert, {
          message: (_label$fileHint = label.fileHint) !== null && _label$fileHint !== void 0 ? _label$fileHint : /*#__PURE__*/_jsxs(_Fragment, {
            children: [label.imageLimit, " ", /*#__PURE__*/_jsxs("strong", {
              children: [imageLimitMb, "MB"]
            }), ". ", label.resizeImageInfo]
          })
        })
      })]
    });
  };

  var renderContent = function renderContent() {
    if (signedUrl) {
      return /*#__PURE__*/_jsxs(StyledPreviewArea, {
        children: [/*#__PURE__*/_jsx(StyledSpaceContainer, {
          direction: "horizontal",
          size: "small",
          children: /*#__PURE__*/_jsx(StyledEditingButton, {
            disabled: disabled || isUploading,
            icon: /*#__PURE__*/_jsx(DeleteOutlined, {}),
            onClick: onDeleteFile
          })
        }), /*#__PURE__*/_jsx(StyledImage, {
          src: signedUrl,
          alt: label.previewAlt
        })]
      });
    }

    return renderUploadField();
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderContent()
  });
};